import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 20 19"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFFFFF" transform="translate(-506 -255)">
          <g transform="translate(506 255.5)">
            <path d="M8 17v-6h4v6h5V9h3L10 0 0 9h3v8h5z"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
